import { jsx as r } from "react/jsx-runtime";

import o from "../../hooks/useTableContext/index.js";

import { COLOR_VARIANTS as e } from "../../../../constants/index.js";

import { Row as t } from "react-aria-components";

import n from "../../../../utils/classNames/index.js";

const a = ({children: a, id: s, className: i, onAction: c, ...m}) => {
    const {variant: d, rowSeparator: l, colorVariant: p} = o();
    return r(t, {
        ...m,
        id: s,
        onAction: c,
        className: n("bg-white", p === e.secondary ? "hover:bg-secondary-100" : "hover:bg-primary-100", !!c && "cursor-pointer", l && "border-b border-neutral-300", "striped" === d && "even:bg-neutral-100", i),
        children: a
    });
};

export { a as default };
//# sourceMappingURL=index.js.map
